// project imports
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';
import AppRouter from './routes';
import { BrowserRouter } from 'react-router';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </ScrollTop>
    </ThemeCustomization>
  );
}
